export default "__VITE_PUBLIC_ASSET__b79e30b3__"